import styled from "styled-components"

export const NavbarStyle = styled.nav `
padding: 8px 0;
position: fixed;
width: 100%;
top: 0;
left: 0;
display: flex;
font-size: 20px;
align-items: center;
justify-content: space-between;
background-color: rgb(255, 255, 255);
z-index: 100;
box-sizing: border-box;

  @media (max-width: 768px) {
    font-size: 18px;
    padding: 0;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`

